import * as React from "react";
// import Box from "@mui/material/Box";
// import Alert from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
// import Collapse from "@mui/material/Collapse";
import CloseIcon from "@mui/icons-material/Close";
import { useAlert } from "../../context/AlertContext";
import {  Avatar, Box, Snackbar, Typography } from "@mui/material";
import logo from "../../assets/images/favicon.png";
// import styles from "./style";
export default function TransitionAlerts() {
  const {alert,hideAlert} = useAlert();
  React.useEffect(() => {
    let timer;
    if (alert?.message) {
      timer = setTimeout(() => {
        hideAlert();
      }, 2000); // Hide after 2 seconds
    }
    return () => clearTimeout(timer);
  }, [alert, hideAlert]); 
  return (
    <>
      {alert?.message ?
        // <Box sx={styles.mainBox}>
        <Snackbar
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "center",
            horizontal: "center",
          }}
          open={Boolean(alert?.message)}
          autoHideDuration={6000}
          onClose={hideAlert}
        >
          <Box sx={{backgroundColor:alert?.severity === "success" ? "#D4EEDB":"#FBD6D6",width:"30em",display:"flex",flexDirection:"row",borderRadius:"10px",padding:"10px",alignItems:"center",justifyContent:"space-between"}}>
            <Box sx={{display:"flex",flexDirection:"row",alignItems:"center"}}>
              <Avatar src={logo}/>        
              <Box sx={{ml:2, }}>
                <Typography sx={{fontSize:"18px",fontWeight:"500",color:"#003400"}}>{alert?.severity}</Typography>
                <Typography sx={{fontSize:"14px",fontWeight:"500",color:"#003400"}}>{alert.message}</Typography>
              </Box></Box>
            <IconButton onClick={hideAlert}>
              <CloseIcon sx={{color:"#003400"}}/>
            </IconButton>
          </Box>
        </Snackbar>:null}
    </>
  );
}
